module.exports = __webpack_public_path__ + "static/media/044-envelope.0c618dc3.svg";